import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { toast } from 'react-toastify';

export default class CopyShift extends React.Component {
  /**
   * Construct
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      date: '',
    };

    this.onCopy = this.onCopy.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  /**
   * Handle copy of shift
   * @return {void}
   */
  onCopy() {
    if (!this.state.date) {
      toast.error('Selecteer eerst een datum');
      return;
    }

    this.props.onCopy(this.props.shiftId, this.state.date);
  }

  /**
   * Handle the datepicker change
   * @param {string} date
   * @return {void}
   */
  handleDateChange(date) {
    this.setState({
      date,
    });
  }

  /**
   * Render
   * @returns {*}
   */
  render() {
    return (
      <div className="copy-shift">
        <DayPickerInput
          inputProps={{
            className: 'form-control',
          }}
          value={this.state.date}
          onDayChange={this.handleDateChange}
        />

        <button
          className="btn btn--white modal__copy"
          onClick={this.onCopy}
        >
          <FontAwesomeIcon icon="copy"/> Kopi&euml;ren
        </button>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Grid/CopyShift.js